// import Request from 'gd-request';
import Request from '../../../../src/core/gd/data/request'
import SupportTicket from "../../model2/support-ticket/support-ticket";

export default class ApiSupport {

    constructor() {}

    static ticketCreateV3(supportTicket:SupportTicket, attachments:any[]) {

        return new Request(this,'POST','support/create-ticket',{
            type            : supportTicket.ticketTypeId,
            subject         : supportTicket.subject,
            message         : supportTicket.description,
            attachments     : attachments,
            platform        : supportTicket.platform,
            pageUrl         : supportTicket.url
        });
    }

    static selectDashboardData() {
        return new Request(this,'GET','support/help-support',{})
    }

    static selectTicketViewV2(ticketId:ID) {
        return new Request(this,'GET','support/ticket-v2/'+ticketId,{});
    }

    static joinCommunity() {
        return new Request(this,'GET','community/join',{});
    }


    // old

    rateUserExperience(rating:any, message:string, myWorkId:any, params:any) {
        return new Request(this,'POST','support/rate-experience',{
            rating: rating,
            message: message,
            myWorkId: myWorkId,
            params: params
        });
    }

    suggestFeature(subject:string, message:string) {
        return new Request(this,'POST','support/suggest-feature',{
            subject: subject,
            message: message
        });
    }

    ticketCreateV2(type:any, subject:string, message:string, attachments:any[]) {
        return new Request(this,'POST','support/create-ticket',{
            type            : type,
            subject         : subject,
            message         : message,
            attachments     : attachments
        });
    }

    ticketCreate(type:number, subject:string, message:string, attachments:any[]) {
        return new Request(this,'POST','support/tickets',{
            type            : type,
            subject         : subject,
            message         : message,
            attachments     : attachments
        });
    }

    ticketView(ticketId:ID) {
        return new Request(this,'GET','support/ticket/'+ticketId,{});
    }

    // ticketViewV2(ticketId:ID) {
    //     return new Request(this,'GET','support/ticket-v2/'+ticketId,{});
    // }

    ticketReplyV2(ticketId:ID, message:string, attachments:any[]) {
        return new Request(this,'POST','support/ticket-v2/'+ticketId,{
            message     : message,
            attachments : attachments
        });
    }

    ticketReply(ticketId:ID, message:string, attachments:any[]) {
        return new Request(this,'POST','support/ticket/'+ticketId,{
            message     : message,
            attachments : attachments
        });
    }

}
